import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../../shared/base-api-template-service.model';
import {Core2Config} from '../../../shared/core2Config';
import{ DriverRegionLinkContainerModel} from '../../../../../../../models/aggregates/erp/delivery/driver-region-link/driver-region-link-container.model';




@Injectable({
  providedIn: 'root'
})
export class DriverRegionLinkService extends BaseApiTemplateService<DriverRegionLinkContainerModel> {
    // https://api-test.akaun.com/core2/tnt/dm/del/driver-region-links
  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/driver-region-links';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/driver-region-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/driver-region-links';
    this.httpClient = http;
  }
}